import { dashboardPanelistTypes } from "../../types";
const initialState = {
    data: [],
    loading: false,
    error: ""
}
const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case dashboardPanelistTypes.FETCH:
            return { ...state, loading: true }
        case dashboardPanelistTypes.SUCCESS:
            return { ...state, data: payload, loading: false, error: "", }
        case dashboardPanelistTypes.ERROR:
            return { ...state, loading: false, error: payload }
        case dashboardPanelistTypes.RESET:
            return initialState;
        default:
            return state;
    }
}

export default reducer;